module.exports = __webpack_public_path__ + "static/media/jacksonAbarca.f2bba7f2.jpg";